export default __webpack_public_path__ + "static/media/Image 78@2x.6496e1dd.png";